import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

const Card = props => {
  const {
    title,
    description,
    link,
    image,
    icon,
    className,
    divClassName,
    emptiesSearchesOnClick,
    subtitle,
    ...otherProps
  } = props;

  const cssScrollbarStyling = _ => {
    return ["Firefox", "Trident", "Edge"].some(browser => {
      return navigator.userAgent.indexOf(browser) >= 0;
    });
  };

  return (
    <Link
      className={classnames(
        `text-black no-underline flex hover:text-blue`,
        className
      )}
      onClick={emptiesSearchesOnClick}
      {...otherProps}
      to={link}
    >
      <div
        className={classnames(
          `border-b-2 shadow hover:shadow-md transition w-full bg-white rounded-lg p-4 flex leading-normal`,
          divClassName
        )}
      >
        {image && (
          <div className="w-1/4 mr-2">
            <img className="rounded-full" src={image} alt={title} />
          </div>
        )}

        <div
          className={`self-center${image && " w-3/4"}${image && " md:mb-2"}`}
        >
          <div className={`font-normal text-xl ${image && "md:mb-2"}`}>
            {icon && <span className="align-middle mx-2">{icon}</span>}
            {title}
            {subtitle && <p className="text-grey text-sm">{subtitle}</p>}
          </div>

          {description && (
            <p
              className="text-grey-darker tracking-normal text-base p-2 h-20 hidden md:block"
              style={
                cssScrollbarStyling()
                  ? { overflow: "hidden" }
                  : {
                      overflow: "auto",
                      OTextOverflow: "ellipsis",
                      textOverflow: "ellipsis"
                    }
              }
            >
              {description}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Cards.js